<template>
    <div class="esia">
        <PreLoader v-if="isLoading"/>
        <h4>EKyzmat</h4>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import PreLoader from '@/components/preloader/PreLoader'

export default {
  components: {
    PreLoader
  },
  data () {
    return {
      isLoading: false
    }
  },
  created () {
    this.authenticate(this.$route.query.code, this.$route.query.state)
  },
  computed: {
    ...mapState('account', ['onError'])
  },
  methods: {
    ...mapActions('account', ['authenticateByEkyzmat']),
    authenticate (code, state) {
      this.isLoading = true
      this.authenticateByEkyzmat({ code, state })
    }

  },
  watch: {
    onError (message) {
      if (message) {
        this.isLoading = false
        this.$store.state.account.onError = ''
        this.$router.push('/login', () => {
          this.$toast.error(message === 'directorError' ? this.$t('directorError') : 'Ошибка при авторизации')
        })
      }
    }
  }
}
</script>
